import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

const usePageTracking = (gtmId?: string, page?: string, preview?: boolean) => {
  useEffect(() => {
    if (gtmId && !preview) {
      TagManager.dataLayer({
        dataLayer: {
          event: 'pageview',
          page,
        },
      });
    }
  }, [gtmId, page, preview]);
};

export default usePageTracking;
